/* FILE: ./frontend/src/components/PrivateRoute.jsx */
import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

export default function PrivateRoute({ children }) {
  // ⚡ INJECTED userProfile to monitor database completeness
  const { user, userProfile, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="flex justify-center items-center h-64">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
      </div>
    );
  }

  if (!user) {
    // Redirect to login, but remember where they were trying to go
    return <Navigate to="/login" state={{ returnTo: location.pathname }} replace />;
  }

  // ⚡ THE FIX: Identify admins based on database role or your specific super admin email
  const isAdmin = userProfile?.role === 'admin' || user?.email?.toLowerCase() === 'admin@shaikh.net.in';

  // ⚡ THE GLOBAL GHOST TRAP
  // If the user has a valid session but bypassed the Profile step, lock them out of the app
  // Admins are fully exempt from this trap.
  if (userProfile && !isAdmin && (!userProfile.contact_person || !userProfile.company_name)) {
      // ⚡ Force them to the Registration component (which auto-detects the missing profile and shows Step 3)
      return <Navigate to="/register" state={{ returnTo: location.pathname }} replace />;
  }

  return children;
}